import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Grid,
  Pagination,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import { capitalize, uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  clearBillingCollectionReport,
  getBillingCollectionReportData,
  updateClinicUserCollectionRefund,
} from "../../../redux/reducers/clinicSlice";
import { updatePaymentModeByCollectionId } from "../../../redux/reducers/paymentSlice";
import { AppColors } from "../../../util/AppColors";
import { rolesToCreateInventory } from "../../../util/arrayList";
import { a4PrintConfig } from "../../../util/commonConfig";
import { w20h20BlueIcon } from "../../../util/CommonIconStyle";
import {
  collectionReportRanges,
  collectionReportTypes,
  paymentSourceTypes,
} from "../../../util/dropList";
import { tabEnum } from "../../../util/enum";
import { printFromNode, warmPrintFrame } from "../../../util/fastPrint";
import { getRightSaluation } from "../../../util/function";
import { canWriteModule } from "../../../util/roleModuleAccess";
import { baseURL } from "../../../util/server";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import ContentToPrint from "../../CommonScreens/ContentToPrint/ContentToPrint";
import ReportTable from "../Reports/ReportTable";

const reportMap = {
  All: "All",
  Revenue: "Revenue Report",
  "Credit Collection": "Credits Collection Report",
  "Credit Usage": "Credits Usage Report",
  Refund: "Refunds Report",
};

const tableHdrs = [
  "invoiceNumber",
  "receiptNo",
  // "invoiceDate",
  "customerUserName",
  "paymentDate",
  "source",
  "amtPaid",
  "paymentMode",
  "extraStatus",
  // "totalDue",
  // "balanceDue",
  // "discount",
  // "discountCode",
  // "taxes",
  // "customerUserName",
  // "petName",
];

const initSearch = {
  invoiceNumber: "",
  paymentMode: [],
  userName: "",
  petName: "",
  source: [],
  type: "All",
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = [
  "Invoice Number",
  "Invoice Date",
  "Receipt No.",
  "Payment Date",
  "Amount Paid",
  "Total Due",
  "Balance Due",
  "Discount",
  // "Discount Code",
  "Taxes",
  // "Source",
];
const dropFields = ["Discount Code", "Source"];
const splitRows = [
  "Invoice Date",
  "Payment Date",
  "Amount Paid",
  "Total Due",
  "Balance Due",
  "Discount",
  "Taxes",
];
const initValues = {
  collectionId: null,
  visible: false,
  err: false,
  value: null,
};
const initDownValues = {
  reportType: "Revenue Report",
  rangeType: "Month",
  startDate: null,
  endDate: null,
};
const defObj = { clinic: {}, vets: [], paymentMethods: [] };

const BillingCollectionsTableReport = ({
  paymentTableType,
  setPaymentTableType,
}) => {
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const allCollectionFetchedRef = useRef(false);
  const skipNextCollectionFetchRef = useRef(false);
  const [editColModVsble, setEditColModVsble] = useState(false);
  const [slctedColction, setSlctedColction] = useState(false);
  const [printVsble, setPrintVsble] = useState(false);
  const [page, setPage] = useState(1);
  const [downloadModVsble, setDownloadModVsble] = useState(false);
  const [downloadValues, setDownloadValues] = useState(initDownValues);
  const [editModValues, setEditModvalues] = useState(initValues);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    discountCodes,
    billingCollectionReport,
    billingAllCollectionReport,
    details: clinicDetails,
  } = useSelector((state) => state?.clinic);
  const rowsPerPage = 10;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    clinic: clinicData,
    vets: clinicVets,
    paymentMethods,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        paymentMethods: Array.isArray(reqData?.paymentMethods)
          ? reqData?.paymentMethods
          : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw]);
  const clinicDet = clinicData;
  const role = localStorage.getItem("role");
  const canManageBilling = canWriteModule("billing");

  useEffect(() => {
    setSearchValues(initSearch);
    setFilterValues({ ...initFilter, selectedList: [], values: {} });
  }, [dispatch]);

  useEffect(() => {
    if (paymentTableType === "today") {
      const reqObj = {
        ...filterValues,
        selectedList: [...(filterValues?.selectedList ?? []), "Payment Date"],
        values: {
          ...(filterValues?.values ?? {}),
          "Start Payment Date": new Date(),
          "End Payment Date": new Date(),
        },
      };
      skipNextCollectionFetchRef.current = true;
      setFilterValues(reqObj);
      onApiCall(1, false, reqObj);
      setPaymentTableType(null);
    }
  }, [paymentTableType]);

  useEffect(() => {
    if (paymentTableType) return;
    if (skipNextCollectionFetchRef.current) {
      skipNextCollectionFetchRef.current = false;
      return;
    }

    dispatch(clearBillingCollectionReport());

    const timeoutId = setTimeout(() => {
      void (async () => {
        // Collection list first — wait for response, then all-collection (once)
        await onApiCall();
        // if (!allCollectionFetchedRef.current) {
        //   allCollectionFetchedRef.current = true;
        //   dispatch(getBillingAllCollectionReportData());
        // }
      })();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    // searchValues?.invoiceNumber,
    searchValues?.paymentMode,
    searchValues?.userName,
    searchValues?.petName,
    searchValues?.source,
    searchValues?.type,
    paymentTableType,
  ]);

  const getFilterObj = (currentPage = 1, reset = false, filterObj = null) => {
    setPage(currentPage);
    const reqObj = {
      page: currentPage,
      itemSize: rowsPerPage,
    };
    if (searchValues?.type !== "All") reqObj.type = searchValues?.type;
    const filValues = filterObj ?? filterValues;
    if (reset) return reqObj;
    // if (searchValues?.invoiceNumber?.length > 0) {
    //   reqObj.invoiceNo = searchValues?.invoiceNumber;
    // }
    if (searchValues?.paymentMode?.length > 0) {
      reqObj.paymentMode = searchValues?.paymentMode?.map((li) => li?.value);
    }
    if (searchValues?.userName?.length > 0) {
      reqObj.userName = searchValues?.userName;
    }
    if (searchValues?.petName?.length > 0) {
      reqObj.petName = searchValues?.petName;
    }
    if (searchValues?.source?.length > 0) {
      reqObj.source = Array.isArray(searchValues?.source)
        ? searchValues?.source?.some((li) => li?.value?.toLowerCase() === "all")
          ? ["Clinic", "PETSHOP", "Pharmacy"]
          : (searchValues?.source ?? [])?.map((li) => li?.apiValue)
        : [];
    }

    if (
      filValues?.selectedList?.includes("Invoice Number") &&
      filValues?.values?.["Invoice Number"]?.length > 0
    ) {
      reqObj.invoiceNo = filValues?.values?.["Invoice Number"];
    }
    if (
      filValues?.selectedList?.includes("Receipt No.") &&
      filValues?.values?.["Receipt No."]?.length > 0
    ) {
      reqObj.receiptNo = filValues?.values?.["Receipt No."];
    }
    if (filValues?.selectedList?.includes("Invoice Date")) {
      reqObj.startInvoiceDate = moment(
        new Date(filValues?.values?.["Start Invoice Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.endInvoiceDate = moment(
        new Date(
          filValues?.values?.["End Invoice Date"] ??
            filValues?.values?.["Start Invoice Date"] ??
            new Date(),
        ),
      ).format("YYYY-MM-DD");
    }
    if (filValues?.selectedList?.includes("Payment Date")) {
      reqObj.startPaymentDate = moment(
        new Date(filValues?.values?.["Start Payment Date"] ?? new Date()),
      ).format("YYYY-MM-DD");
      reqObj.endPaymentDate = moment(
        new Date(
          filValues?.values?.["End Payment Date"] ??
            filValues?.values?.["Start Payment Date"] ??
            new Date(),
        ),
      ).format("YYYY-MM-DD");
    }
    if (filValues?.selectedList?.includes("Amount Paid")) {
      reqObj.minAmountPaid = Number(
        filValues?.values?.["Min Amount Paid"] ?? 0,
      );
      reqObj.maxAmountPaid = Number(
        filValues?.values?.["Max Amount Paid"] ?? 0,
      );
    }
    if (filValues?.selectedList?.includes("Total Due")) {
      reqObj.minTotalDue = Number(filValues?.values?.["Min Total Due"] ?? 0);
      reqObj.maxTotalDue = Number(filValues?.values?.["Max Total Due"] ?? 0);
    }
    if (filValues?.selectedList?.includes("Balance Due")) {
      reqObj.minBalanceDue = Number(
        filValues?.values?.["Min Balance Due"] ?? 0,
      );
      reqObj.maxBalanceDue = Number(
        filValues?.values?.["Max Balance Due"] ?? 0,
      );
    }
    if (filValues?.selectedList?.includes("Discount")) {
      reqObj.minDiscount = Number(filValues?.values?.["Min Discount"] ?? 0);
      reqObj.maxDiscount = Number(filValues?.values?.["Max Discount"] ?? 0);
    }
    // if (filValues?.selectedList?.includes("Discount Code")) {
    //   reqObj.discountCode = filValues?.values?.["Discount Code"]?.map(
    //     (li) => li?.value,
    //   );
    // }
    if (filValues?.selectedList?.includes("Taxes")) {
      reqObj.minTaxes = Number(filValues?.values?.["Min Taxes"] ?? 0);
      reqObj.maxTaxes = Number(filValues?.values?.["Max Taxes"] ?? 0);
    }
    // if (filValues?.selectedList?.includes("Source")) {
    //   reqObj.source = Array.isArray(filValues?.values?.["Source"])
    //     ? filValues?.values?.["Source"]?.some(
    //         (li) => li?.value?.toLowerCase() === "all",
    //       )
    //       ? ["Clinic", "Pet Shop", "Pharmacy"]
    //       : (filValues?.values?.["Source"] ?? [])?.map((li) => li?.value)
    //     : [];
    // }
    return reqObj;
  };

  const onApiCall = (pge = 1, reset = false, filterObj = null) => {
    return dispatch(
      getBillingCollectionReportData(getFilterObj(pge, reset, filterObj)),
    );
  };

  const totalPage = Math.ceil(
    (billingCollectionReport?.totalRecords ?? 0) / rowsPerPage,
  );

  const handleChangePage = (e, selectedPage) => {
    onApiCall(selectedPage);
  };

  const handleEdit = (itm) => {
    setEditModvalues({
      ...editModValues,
      visible: true,
      collectionId: itm?.collectionId,
      value: { name: itm?.paymentMode, value: itm?.paymentMode },
      oldPaymentMode: itm?.paymentMode ?? "",
      advanceAmount: itm?.advanceAmount ?? null,
      amountPaid: itm?.amountPaid ?? null,
      userId: itm?.userId ?? null,
      userName: itm?.userName ?? "",
      petName: itm?.petName ?? "",
      petId: itm?.petId ?? null,
      creditErr: "",
    });
  };

  const onCloseEditMod = () => {
    setEditModvalues(initValues);
  };

  const handlePrint = (dta) => {
    setSlctedColction(dta);
    setPrintVsble(true);
  };

  const getTableData = () => {
    return (billingCollectionReport?.data ?? [])?.map((li) => {
      const reqDiscountCodes = (
        Array.isArray(li?.dicountCode) ? li?.dicountCode : []
      )?.map((nl) => {
        const reqCode = discountCodes?.find(
          (dc) => (dc?.billId ?? "")?.toString() === nl,
        );
        if (reqCode) return reqCode?.discountCode ?? "";
        return "";
      });
      return {
        source: tabEnum?.[li?.source],
        invoiceNumber: li?.invoiceNo,
        receiptNo: li?.receiptNo,
        invoiceDate: moment(new Date(li?.invoiceDate)).format("DD MMM YYYY"),
        paymentDate: moment(new Date(li?.paymentDate)).format("DD MMM YYYY"),
        amtPaid: Number(li?.amountPaid)?.toFixed(2),
        paymentMode: li?.paymentMode,
        totalDue: Number(li?.totalDue ?? 0)?.toFixed(2),
        balanceDue: Number(li?.balanceDue ?? 0)?.toFixed(2),
        discount: Number(li?.dicount ?? 0)?.toFixed(2),
        discountCode: reqDiscountCodes,
        taxes: Number(li?.taxes ?? 0)?.toFixed(2),
        customerUserName: li?.userName ?? "",
        petName: li?.petName ?? "",
        extraStatus: (
          <div className="flex-row-ali-cen">
            {canManageBilling ? (
              <div className="cursor" onClick={() => handleEdit(li)}>
                <div className="flex-center">
                  <EditIcon sx={w20h20BlueIcon} />
                </div>
                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                  Edit
                </Typography>
              </div>
            ) : null}
            <div className="cursor ml20" onClick={() => handlePrint(li)}>
              <div className="flex-center">
                <PrintIcon sx={w20h20BlueIcon} />
              </div>
              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                Print
              </Typography>
            </div>
          </div>
        ),
      };
    });
  };

  const handleOpenChart = () => {
    console.log("Log triggered");
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    };
    if (name === "type") {
      // if (
      //   value === "Revenue" ||
      //   value === "Credit Collection" ||
      //   value === "Refund"
      // ) {
      // }
      if (value === "Credit Usage") {
        reqObj.paymentMode = [
          { name: "Advance Adjustment", value: "Advance Adjustment" },
        ];
      } else {
        const extraModes = ["Advance Adjustment", "Refund to Deposit"];
        const reqPaymentMode = reqObj?.paymentMode?.filter(
          (pm) => !extraModes.includes(pm?.value),
        );
        reqObj.paymentMode = reqPaymentMode;
      }
    }
    setSearchValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({ ...initFilter, selectedList: [], values: {} });
    });
    onApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const getPetNames = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => li?.petName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getUserNames = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => li?.userName)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const getPaymentModes = () => {
    const reqList = (paymentMethods ?? [])
      ?.filter((li) => li?.status)
      ?.map((li) => (li?.name ?? "")?.toLowerCase())
      ?.filter(Boolean);
    // const uniqList = uniq(reqList);
    const reqDropList = reqList?.map((li) => ({
      name: capitalize(li),
      value: li,
    }));
    if (
      searchValues?.type === "Credit Usage" ||
      searchValues?.type === "Refund"
    ) {
      reqDropList.unshift({
        name: "Advance Adjustment",
        value: "Advance Adjustment",
      });
    }
    if (searchValues?.type === "Refund" || searchValues?.type === "All") {
      reqDropList.unshift({
        name: "Refund to Deposit",
        value: "Refund to Deposit",
      });
    }
    return reqDropList?.sort((a, b) =>
      (a?.name ?? "")?.localeCompare(b?.name ?? "", undefined, {
        sensitivity: "base",
      }),
    );
  };

  const getInvoiceNumbers = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.map((li) => li?.invoiceNo)
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    return uniqList;
  };

  const onApplyFilter = () => {
    onApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const getFieldName = (name, type) => {
    if (name === "Invoice Date") {
      if (type === "start") return "Start Invoice Date";
      return "End Invoice Date";
    }
    if (name === "Payment Date") {
      if (type === "start") return "Start Payment Date";
      return "End Payment Date";
    }
    if (name === "Total Due") {
      if (type === "start") return "Min Total Due";
      return "Max Total Due";
    }
    if (name === "Amount Paid") {
      if (type === "start") return "Min Amount Paid";
      return "Max Amount Paid";
    }
    if (name === "Balance Due") {
      if (type === "start") return "Min Balance Due";
      return "Max Balance Due";
    }
    if (name === "Discount") {
      if (type === "start") return "Min Discount";
      return "Max Discount";
    }
    if (name === "Taxes") {
      if (type === "start") return "Min Taxes";
      return "Max Taxes";
    }
  };

  const getDiscountCodes = () => {
    const reqList = (billingAllCollectionReport?.data ?? [])
      ?.flatMap((li) => [
        ...(li?.petShopDiscountId ?? []),
        ...(li?.pharmacyDiscountId ?? []),
        ...(li?.treatmentDiscountId ?? []),
      ])
      ?.filter(Boolean);
    const uniqList = uniq(reqList);
    const reqDropList = uniqList?.map((li) => {
      const reqCode = (discountCodes ?? [])?.find(
        (dc) => (dc?.billId ?? "")?.toString() === li,
      );
      return {
        name: reqCode?.discountCode ?? "",
        value: reqCode?.discountCode ?? "",
      };
    });
    return reqDropList;
  };

  const getDropListByType = (typ) => {
    return typ === "Discount Code"
      ? getDiscountCodes()
      : typ === "Source"
        ? paymentSourceTypes
        : [];
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const handleDownlaod = () => {
    setDownloadValues({
      ...downloadValues,
      reportType: reportMap?.[searchValues?.type],
    });
    setDownloadModVsble(true);
  };

  const onDownloadReport = () => {
    // const todayDate = moment(new Date()).format("YYYY-MM-DD");
    // const thirtyDaysAgo = moment(
    //   new Date(new Date().setDate(new Date().getDate() - 30)),
    // ).format("YYYY-MM-DD");
    let reqStartPaymentDate = new Date(),
      reqEndPaymentDate = new Date();
    const rangeType = downloadValues?.rangeType;
    if (rangeType === "Yesterday") {
      const yesterday = moment().subtract(1, "day").toDate();
      reqStartPaymentDate = yesterday;
      reqEndPaymentDate = yesterday;
    }
    if (rangeType === "Week") {
      reqStartPaymentDate = moment().subtract(6, "days").toDate();
      reqEndPaymentDate = new Date();
    }
    if (rangeType === "Month") {
      reqStartPaymentDate = moment().startOf("month").toDate();
      reqEndPaymentDate = new Date();
    }
    if (rangeType === "Custom") {
      reqStartPaymentDate = new Date(downloadValues?.startDate ?? new Date());
      reqEndPaymentDate = new Date(downloadValues?.endDate ?? new Date());
    }
    let url = `${baseURL}/clinic/payment/collection/dashboard-reports/export?clinicId=${clinicDet?.id}&type=${downloadValues?.reportType}&startPaymentDate=${moment(reqStartPaymentDate).format("YYYY-MM-DD")}&endPaymentDate=${moment(reqEndPaymentDate).format("YYYY-MM-DD")}`;
    // let url = `${baseURL}/clinic/payment/collection/download-daily?clinicId=${clinicDet?.id}&type=${searchValues?.type}&startPaymentDate=${moment(reqStartPaymentDate).format("YYYY-MM-DD")}&endPaymentDate=${moment(reqEndPaymentDate).format("YYYY-MM-DD")}`;
    if (searchValues?.paymentMode?.length > 0) {
      url += `&paymentMode=${searchValues?.paymentMode?.map((li) => li?.value)}`;
    }
    if (searchValues?.userName?.length > 0) {
      url += `&userName=${searchValues?.userName}`;
    }
    if (searchValues?.petName?.length > 0) {
      url += `&petName=${searchValues?.petName}`;
    }
    if (searchValues?.source?.length > 0) {
      url += `&source=${
        Array.isArray(searchValues?.source)
          ? searchValues?.source?.some(
              (li) => li?.value?.toLowerCase() === "all",
            )
            ? ["Clinic", "PETSHOP", "Pharmacy"]
            : (searchValues?.source ?? [])?.map((li) => li?.apiValue)
          : []
      }`;
    }
    if (
      filterValues?.selectedList?.includes("Invoice Number") &&
      filterValues?.values?.["Invoice Number"]?.length > 0
    ) {
      url += `&invoiceNo=${filterValues?.values?.["Invoice Number"]}`;
    }
    if (
      filterValues?.selectedList?.includes("Receipt No.") &&
      filterValues?.values?.["Receipt No."]?.length > 0
    ) {
      url += `&receiptNo=${filterValues?.values?.["Receipt No."]}`;
    }
    // if (filterValues?.selectedList?.includes("Invoice Date")) {
    //   url += `&startInvoiceDate=${moment(
    //     new Date(filterValues?.values?.["Start Invoice Date"] ?? new Date()),
    //   ).format("YYYY-MM-DD")}&endInvoiceDate=${moment(
    //     new Date(
    //       filterValues?.values?.["End Invoice Date"] ??
    //         filterValues?.values?.["Start Invoice Date"] ??
    //         new Date(),
    //     ),
    //   ).format("YYYY-MM-DD")}`;
    // }
    // if (filterValues?.selectedList?.includes("Payment Date")) {
    //   url += `&startPaymentDate=${moment(
    //     new Date(filterValues?.values?.["Start Payment Date"] ?? new Date()),
    //   ).format("YYYY-MM-DD")}&endPaymentDate=${moment(
    //     new Date(
    //       filterValues?.values?.["End Payment Date"] ??
    //         filterValues?.values?.["Start Payment Date"] ??
    //         new Date(),
    //     ),
    //   ).format("YYYY-MM-DD")}`;
    // } else {
    //   url += `&startPaymentDate=${moment(startPaymentDate).format(
    //     "YYYY-MM-DD",
    //   )}&endPaymentDate=${moment(endPaymentDate).format("YYYY-MM-DD")}`;
    // }
    if (filterValues?.selectedList?.includes("Amount Paid")) {
      url += `&minAmountPaid=${Number(
        filterValues?.values?.["Min Amount Paid"] ?? 0,
      )}&maxAmountPaid=${Number(
        filterValues?.values?.["Max Amount Paid"] ?? 0,
      )}`;
    }
    if (filterValues?.selectedList?.includes("Total Due")) {
      url += `&minTotalDue=${Number(filterValues?.values?.["Min Total Due"] ?? 0)}&maxTotalDue=${Number(filterValues?.values?.["Max Total Due"] ?? 0)}`;
    }
    if (filterValues?.selectedList?.includes("Balance Due")) {
      url += `&minBalanceDue=${Number(
        filterValues?.values?.["Min Balance Due"] ?? 0,
      )}&maxBalanceDue=${Number(
        filterValues?.values?.["Max Balance Due"] ?? 0,
      )}`;
    }
    if (filterValues?.selectedList?.includes("Discount")) {
      url += `&minDiscount=${Number(filterValues?.values?.["Min Discount"] ?? 0)}&maxDiscount=${Number(filterValues?.values?.["Max Discount"] ?? 0)}`;
    }
    if (filterValues?.selectedList?.includes("Taxes")) {
      url += `&minTaxes=${Number(filterValues?.values?.["Min Taxes"] ?? 0)}&maxTaxes=${Number(filterValues?.values?.["Max Taxes"] ?? 0)}`;
    }
    // const url = `${baseURL}/clinic/payment/collection/download-daily?startDate=${thirtyDaysAgo}&endDate=${todayDate}&clinicId=${clinicDet?.id}`;
    onCloseDownloadMod();
    window.open(url, "_blank");
  };

  const isAdvanceAdjustmentMode = (value) =>
    String(value ?? "")
      ?.replace(/\s+/g, "")
      ?.toLowerCase() === "advanceadjustment";

  const onChangeModValue = (val) => {
    setEditModvalues({
      ...editModValues,
      value: val,
      err: val?.value ? false : true,
      creditErr: "",
    });
  };

  const updatePaymentMode = () => {
    if (!editModValues?.value?.value) {
      return setEditModvalues({ ...editModValues, err: true, creditErr: "" });
    }
    if (
      isAdvanceAdjustmentMode(editModValues?.value?.value) &&
      Number(editModValues?.advanceAmount ?? 0) <
        Number(editModValues?.amountPaid ?? 0)
    ) {
      return setEditModvalues({
        ...editModValues,
        err: false,
        creditErr: "Insufficient credit balance",
      });
    }
    if (!editModValues?.collectionId) return;
    dispatch(
      updatePaymentModeByCollectionId({
        collectionId: editModValues?.collectionId,
        url: `?paymentMode=${editModValues?.value?.value}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        const oldMode = editModValues?.oldPaymentMode ?? "";
        const newMode = editModValues?.value?.value ?? "";
        const normalizeMode = (value) =>
          String(value ?? "")
            ?.replace(/\s+/g, "")
            ?.toLowerCase();
        const wasAdvance = isAdvanceAdjustmentMode(oldMode);
        const isAdvance = isAdvanceAdjustmentMode(newMode);
        if (
          editModValues?.userId &&
          normalizeMode(oldMode) !== normalizeMode(newMode) &&
          wasAdvance !== isAdvance
        ) {
          const amount = Math.abs(Number(editModValues?.amountPaid ?? 0));
          const form = new FormData();
          if (editModValues?.userName) {
            form.append("userName", editModValues.userName);
          }
          if (editModValues?.petName && editModValues?.petId) {
            form.append("petName", editModValues.petName);
            form.append("petId", editModValues.petId);
          }
          if (!wasAdvance && isAdvance) {
            form.append("paymentType", "Refund");
            form.append("advanceAmount", Number(-amount));
            form.append("paymentMode", oldMode);
            form.append("reason", "Taken from Credit");
          } else {
            form.append("paymentType", "Collect");
            form.append("advanceAmount", Number(amount));
            form.append("paymentMode", newMode);
            form.append("reason", "Returned to Credit");
          }
          dispatch(
            updateClinicUserCollectionRefund({
              userId: editModValues.userId,
              form,
              silent: true,
            }),
          );
        }
        onApiCall(page);
        onCloseEditMod();
      }
    });
  };

  useEffect(() => {
    if (!printVsble || typeof window === "undefined") return;
    let cancelled = false;
    const warm = () => {
      if (cancelled) return;
      const node = contentToPrint.current;
      if (node) warmPrintFrame(node, a4PrintConfig);
    };
    const frameId = requestAnimationFrame(warm);
    const node = contentToPrint.current;
    const imgs = node ? [...node.querySelectorAll("img")] : [];
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", warm, { once: true });
        img.addEventListener("error", warm, { once: true });
      }
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(frameId);
      imgs.forEach((img) => {
        img.removeEventListener("load", warm);
        img.removeEventListener("error", warm);
      });
    };
  }, [printVsble, slctedColction]);

  const handleCollectionPrint = () => {
    printFromNode(contentToPrint.current, {
      title: "",
      pageStyle: a4PrintConfig,
    });
  };

  const onCloseDownloadMod = () => {
    setDownloadModVsble(false);
    setDownloadValues(initDownValues);
  };

  const onDownChange = (name, value) => {
    setDownloadValues({ ...downloadValues, [name]: value });
  };

  return (
    <>
      <div className="flex-row mv10">
        <div className="top-row-cen-con w100Per">
          {/* <div className="w15Per">
            <CustomTextField
              options={getInvoiceNumbers()}
              value={searchValues?.invoiceNumber}
              name="invoiceNumber"
              handleChange={onSearchChange}
              label="Invoice Number"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div> */}
          <div className="w13Per">
            <CustomTextField
              options={getUserNames()}
              value={searchValues?.userName ?? []}
              name="userName"
              handleChange={onSearchChange}
              label="Customer Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w13Per ml15">
            <CustomTextField
              options={getPetNames()}
              value={searchValues?.petName}
              name="petName"
              handleChange={onSearchChange}
              label="Pet Name"
              backgroundColor={AppColors.lightBlue2}
              fullWidth
              suggetions
            />
          </div>
          <div className="w13Per ml15">
            <CustomSelect
              list={paymentSourceTypes}
              value={searchValues?.source ?? []}
              name="source"
              handleChange={onSearchChange}
              label="Source"
              multiSelectSearchCheck
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
          <div className="w13Per ml15">
            <CustomSelect
              list={getPaymentModes()}
              value={searchValues?.paymentMode ?? []}
              name="paymentMode"
              handleChange={onSearchChange}
              label="Payment Mode"
              backgroundColor={AppColors.lightBlue2}
              multiSelectSearchCheck
              disabled={searchValues?.type === "Credit Usage"}
            />
          </div>
          <div
            className="flex-row-ali-cen ml15 filter cursor"
            onClick={() => onFilterChange("visible", true)}
          >
            <TuneIcon sx={{ color: AppColors.appPrimary }} />
            <Typography className="font-medium fs12 blue-color ml10">
              {filterValues?.selectedList?.length > 0
                ? `${filterValues?.selectedList?.length} `
                : ""}
              Filter
            </Typography>
          </div>
          <div className="ml15">
            <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
          </div>
          {rolesToCreateInventory.includes(role) ? (
            <div className="ml15">
              <CustomButton text="⬇" onClick={handleDownlaod} smallBtn />
            </div>
          ) : null}
          <div className="ml15 w13Per">
            <CustomSelect
              list={[
                { name: "All", value: "All" },
                { name: "Payment Collection", value: "Revenue" },
                { name: "Credit Collection", value: "Credit Collection" },
                { name: "Credit Usage", value: "Credit Usage" },
                { name: "Refund", value: "Refund" },
                // { name: "Revenue", value: "Settlement" },
                // { name: "Credit Collection", value: "Deposit" },
                // { name: "Credit Usage", value: "Settlement" },
                // { name: "Refund", value: "Refund" },
              ]}
              value={searchValues?.type ?? []}
              name="type"
              handleChange={onSearchChange}
              label="Type"
              backgroundColor={AppColors.lightBlue2}
              select
            />
          </div>
        </div>
      </div>
      <Typography className="font-medium fs12 gray28 ml30">
        Number of Records: {billingCollectionReport?.totalRecords ?? 0}
      </Typography>
      <div className="mtMin10">
        <ReportTable
          datas={getTableData()}
          columns={tableHdrs}
          maxHeight="56vh"
        />
        <div className="flex1-end mtMin50">
          {Math.ceil(
            (billingCollectionReport?.totalRecords ?? 0) / rowsPerPage,
          ) > 1 ? (
            <TableFooter>
              <TableRow>
                <TableCell colSpan={12}>
                  <div className="flex1-end">
                    <Pagination
                      count={totalPage}
                      variant="outlined"
                      color="primary"
                      page={page}
                      onChange={handleChangePage}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>
          ) : null}
        </div>
      </div>

      <CustomModal
        open={editModValues?.visible}
        onClose={onCloseEditMod}
        header="Change Payment Mode"
        modal
        modalWidth={30}
      >
        <div className="ph20">
          <div className="font-medium fs14 black2">Payment Mode</div>
          <PaymentModeDropdown
            list={[]}
            value={editModValues?.value}
            error={editModValues?.err}
            helperText={editModValues?.err ? "This field is required" : ""}
            onChange={(e) => onChangeModValue(e)}
            name="value"
            label=""
          />
          {String(editModValues?.value?.value ?? "")
            ?.replace(/\s+/g, "")
            ?.toLowerCase() === "advanceadjustment" ? (
            <Typography className="txt-semi-bold fs14 orange5 mt10">
              Available Credit:{" "}
              {editModValues?.advanceAmount != null &&
              editModValues?.advanceAmount !== "" &&
              Number.isFinite(Number(editModValues?.advanceAmount))
                ? Number(editModValues?.advanceAmount).toFixed(2)
                : "-"}
            </Typography>
          ) : null}
          {editModValues?.creditErr ? (
            <Typography className="fs12 red-color mt5">
              {editModValues.creditErr}
            </Typography>
          ) : null}
          <div className="flex-center mv20">
            <div>
              <CustomButton
                smallBtn
                text="Update"
                onClick={updatePaymentMode}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => {
                      return (
                        <div className="mt20">
                          {dropFields?.includes(li) ? (
                            <CustomSelect
                              list={getDropListByType(li)}
                              value={filterValues?.values?.[li] ?? []}
                              name={li}
                              handleChange={onFilterValuesChange}
                              label={li}
                              multiSelectSearchCheck
                            />
                          ) : splitRows?.includes(li) ? (
                            <div className="flex-row-between-align-center">
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "start")}
                                  fullWidth
                                  name={getFieldName(li, "start")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "start")
                                    ] ?? ""
                                  }
                                  label={getFieldName(li, "start")}
                                  mobileDate={
                                    li === "Invoice Date" ||
                                    li === "Payment Date"
                                  }
                                  type="number"
                                />
                              </div>
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder={getFieldName(li, "end")}
                                  fullWidth
                                  name={getFieldName(li, "end")}
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.[
                                      getFieldName(li, "end")
                                    ] ?? ""
                                  }
                                  label={getFieldName(li, "end")}
                                  mobileDate={
                                    li === "Invoice Date" ||
                                    li === "Payment Date"
                                  }
                                  type="number"
                                />
                              </div>
                            </div>
                          ) : (
                            <CustomTextField
                              placeholder={li}
                              fullWidth
                              name={li}
                              handleChange={onFilterValuesChange}
                              value={filterValues?.values?.[li] ?? ""}
                              label={li}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={printVsble}
        onClose={() => setPrintVsble(false)}
        header=""
        // "Prescription"
        headerCenter
        modal
        headerBold
        modalWidth={80}
      >
        <div className="scroll-80vh">
          <ContentToPrint
            ref={contentToPrint}
            footer={
              <div className="prescription-print-footer-inner">
                <div className="mb10 prescription-print-footer-doctor-row">
                  <div className="flex-center">
                    <div className="txt-regular fs12 black">
                      Thank you for the payment
                    </div>
                  </div>
                </div>

                {clinicDet?.footer?.length > 0 ? (
                  <img src={clinicDet?.footer} alt="" />
                ) : null}
              </div>
            }
            header={
              <div className="flex-row-ali-cen mv20">
                <div className="w35Per">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w30Per flex-center">
                  <div className="font-bold fs20 blue-color">
                    Payment Receipt
                  </div>
                </div>
                <div className="w35Per flex1-end">
                  <div className="prescription-doc-header-clinic">
                    <div className="font-bold blue-color fs16">
                      {clinicDet?.name ?? ""}
                    </div>
                    <div className="txt-regular fs12 blue-color">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          TAX ID:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : null}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            }
          >
            <tr>
              <td className="prescription-print-tbody-cell">
                <div className="prescription-print-body-inner">
                  <div className="p5">
                    <div>
                      <div className="flex-row prescription-print-patient-block">
                        <div className="w65Per">
                          <div className="flex-column">
                            <div className="flex-row mv5">
                              {slctedColction?.userName?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color">
                                    Customer:
                                  </div>
                                  <div className="font-bold fs12 black capitalize ml5">
                                    {slctedColction?.userName}
                                  </div>
                                </>
                              ) : null}
                              {slctedColction?.petName?.length > 0 ? (
                                <>
                                  <div
                                    className={`font-bold fs12 blue-color ${slctedColction?.userName?.length > 0 ? "ml10" : ""}`}
                                  >
                                    Pet Name:
                                  </div>
                                  <div className="font-bold fs12 black capitalize ml5">
                                    {slctedColction?.petName}
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        {slctedColction?.doctorName?.length > 0 ? (
                          <div className="w35Per">
                            <div className="flex-column">
                              <div className="flex-row mt10">
                                <div className="font-bold fs12 blue-color">
                                  Vet Name:
                                </div>
                                <div className="font-bold fs12 black ml5 capitalize">
                                  {`${getRightSaluation(clinicVets, slctedColction?.doctorId)}${
                                    slctedColction?.doctorName ?? ""
                                  }`}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="box-hor-split mv10" />
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th className="w10Per">Receipt Date</th>
                            <th className="w15Per">Receipt No.</th>
                            <th className="w10Per">Invoice Date</th>
                            <th className="w15Per">Invoice No.</th>
                            <th className="w15Per">Type</th>
                            <th className="w20Per">Payment Mode</th>
                            <th className="w15Per">Amount Paid</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {moment(
                                new Date(slctedColction?.paymentDate),
                              ).format("DD MMM YYYY")}
                            </td>
                            <td>{slctedColction?.receiptNo ?? ""}</td>
                            <td>
                              {slctedColction?.invoiceDate?.length > 0
                                ? moment(
                                    new Date(slctedColction?.invoiceDate),
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td>{slctedColction?.invoiceNo ?? ""}</td>
                            <td>{slctedColction?.collectionType ?? ""}</td>
                            <td>
                              {slctedColction?.paymentMode ===
                              "advanceAdjustment"
                                ? "Advance Adjustment"
                                : slctedColction?.paymentMode}
                            </td>
                            <td>
                              {Number(slctedColction?.amountPaid ?? 0) > 0
                                ? Number(
                                    slctedColction?.amountPaid ?? 0,
                                  )?.toFixed(2)
                                : "Nil"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="thin-line" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ContentToPrint>
          <div className="flex1-end mv20">
            <div>
              <CustomButton
                text="Print"
                onClick={handleCollectionPrint}
                smallBtn
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={downloadModVsble}
        onClose={onCloseDownloadMod}
        header="Download Report"
        modal
        modalWidth={35}
      >
        <div className="mv10 mh20">
          <div className="black fs14 txt-semi-bold">Report Type</div>
          <CustomCheckbox
            radio
            value={downloadValues?.reportType}
            onChange={(e) => onDownChange("reportType", e?.target?.value)}
            radios={collectionReportTypes}
            defaultValue={downloadValues?.reportType}
            // disabled
          />
          <div className="black fs14 txt-semi-bold">Date Range</div>
          <CustomCheckbox
            radio
            value={downloadValues?.rangeType}
            onChange={(e) => onDownChange("rangeType", e?.target?.value)}
            radios={collectionReportRanges}
            defaultValue={downloadValues?.rangeType}
          />
          {downloadValues?.rangeType === "Custom" ? (
            <div className="flex-row-between">
              <div className="w48Per">
                <div className="black fs14 txt-semi-bold">Start Date</div>
                <CustomTextField
                  value={downloadValues?.startDate}
                  handleChange={(e) =>
                    onDownChange("startDate", e?.target?.value)
                  }
                  fullWidth
                  mobileDate
                />
              </div>
              <div className="w48Per">
                <div className="black fs14 txt-semi-bold">End Date</div>
                <CustomTextField
                  value={downloadValues?.endDate}
                  handleChange={(e) =>
                    onDownChange("endDate", e?.target?.value)
                  }
                  fullWidth
                  mobileDate
                />
              </div>
            </div>
          ) : null}
          <div className="flex-row-ali-cen flex-center mt20">
            <div>
              <CustomButton
                text="Download"
                smallBtn
                onClick={onDownloadReport}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default BillingCollectionsTableReport;
